import React, { useEffect, useState } from "react";
import {
  postModalOtrosParticipantes,
  postProcedimientoDetalles,
  postProcedimientoModificar,
  postTablaInsumosMateralesPaquetes,
} from "../../../services/PaginaRuta";
import TablaProcedimiento from "./TablaProcedimiento";
import ModalOtrosParticipantesCirugia from "./ModalOtrosParticipantesCirugia";
import TablaOtrosParticipantes from "./TablaOtrosParticipantes";
import ModalAgregarProcedimientoDeCirugia from "./ModalAgregarProcedimientoDeCirugia";
import ModalAgregarPaquetesQuirurgicos from "./ModalAgregarPaquetesQuirurgicos"
import TablaPaquetesMaterialesInsumos from "./TablaPaquetesMaterialesInsumos";
import ModalConfirmarGuardarPro from "./ModalConfirmarGuardarPro";

const ModalProcedimiento = ({ idCirugia,user,passDataActualizaTablaPacientes }) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataProcedimiento, setDataProcedimiento] = useState([]);
  const [dataDetallesProcedimiento, setDataDetallesProcedimiento] = useState([]);
  const [dataOtrosParticipantes, setdataOtrosParticipantes] = useState([])
  const [dataInsumosPaquetesMateriales, setdataInsumosPaquetesMateriales]=useState([])
  const [modalOnOtrosParticipantes, setModalOnOtrosParticipantes] = useState(false)
  const [modalOnAgregarProcedimientoCirugia, setmodalOnAgregarProcedimientoCirugia] = useState(false)
  const [modalOnAgregarPaquetesQuirurgicos, setmodalOnAgregarPaquetesQuirurgicos] = useState(false)
  const [modalOnConfirmarGuardar, setmodalOnConfirmarGuardar]=useState(false)
  const [crearProcedimientoSaberCuandoSeCreoYActualizar, setcrearProcedimientoSaberCuandoSeCreoYActualizar]=useState('')
  //const [modificarProcedimientoSaberCuandoSeCreoYActualizar, setmodificarProcedimientoSaberCuandoSeCreoYActualizar]=useState('')

  const handleOnclickGuardar=()=>{
    setmodalOnConfirmarGuardar(true)
  }

  const passActualizarTablaProcedimiento=(data)=>{
    //console.log(data,'passActualizarTablaProcedimiento')
    setcrearProcedimientoSaberCuandoSeCreoYActualizar(data)    
  }

  const handleOnchangeAgregarPaquetesQuirurgicos = ()=>{
    setmodalOnAgregarPaquetesQuirurgicos(true)
  }

  const handleOnclickAgregarProcedimientoCirugia = ()=>{
    setmodalOnAgregarProcedimientoCirugia(true)
  }

  const handleClickOnOtrosParticipantes = ()=>{
    setModalOnOtrosParticipantes(true)
  }
  // const via ={
  //   ABDOMINAL:40,

  // }
  useEffect(() => {
    //setcrearProcedimientoSaberCuandoSeCreoYActualizar(' ')

    //console.log(user,'useruseruser')
    
    const body = {
      vaProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    };
    postProcedimientoModificar(body).then((res) => {
      //console.log(res.data, "procedimiento procedimiento/cirprincipal");
      setDataProcedimiento(res.data[0]);
    });

    postProcedimientoDetalles(body).then((res) => {
      console.log(res.data, "detalles procedimiento/detallesqx");
      setDataDetallesProcedimiento(res.data);
    });

    const bodyOtrosParticipantes = {
      varProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    };

    postModalOtrosParticipantes(bodyOtrosParticipantes).then((res)=>{
      //console.log(res.data,'postModalOtrosParticipantes')
      setdataOtrosParticipantes(res.data)
    })

    postTablaInsumosMateralesPaquetes(bodyOtrosParticipantes).then((res)=>{
      setdataInsumosPaquetesMateriales(res.data)
      //console.log(res.data,'postTablaInsumosMateralesPaquetes')
    })
  }, [crearProcedimientoSaberCuandoSeCreoYActualizar]);
  return (
    <>
      <div>
        <div className="flex-auto overflow-y-auto relative ">
          <div className="flex flex-row   text-left">
            <div className="w-1/4  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                N° Cirugía
              </label>
              <input
                type="text"
                disabled={true}
                defaultValue={dataProcedimiento.ProCirCod}
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
            <div className="w-1/4  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                N° Documento 
              </label>
              <input
                type="text"
                disabled={true}
                defaultValue={dataProcedimiento.MPCedu}
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
            <div className="w-1/4  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Tipo Documento 
              </label>
              <input
                type="text"
                disabled={true}
                defaultValue={dataProcedimiento.MPTDoc}
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
            <div className="w-1/4  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Nombre 
              </label>
              <input
                type="text"
                disabled={true}
                defaultValue={dataProcedimiento.MPNOMC}
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
          </div>
        </div>
        <div className="bg-[#437cdc] mt-3">
        <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl ">
          Procedimientos
        </label>
        </div>
        <div className="mt-3 mb-3">
          <button
            type="button"
            onClick={handleOnclickAgregarProcedimientoCirugia}
            className="block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-[#9e56fe] hover:shadow-lg focus:bg-[#9e56fe] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Agregar Procedimientos de Cirugía
          </button>
        </div>
        <div className="">
          <div className="flex flex-col">
            <div className="overflow-x-auto ">
              <div className="py-1 inline-block min-w-full sm:px-1 ">
                <div className="overflow-hidden">
                  <table className="min-w-full text-center bg-gray-200">
                    <thead className=" ">
                      <tr>
                        <th></th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        ></th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        ></th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Cd. Prod
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Procedimiento
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Can
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Lateralidad
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Cd. Ciruj.
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Nombre Cirujano
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Cd. Espec
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Especialidad
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Honorario de Cirujano
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Descripción de Honorario de Cirugía
                        </th>
                      </tr>
                    </thead>
                    
                      {dataDetallesProcedimiento.map((item, index) => (
                        <TablaProcedimiento key={index} item={item} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento} user={user}/>
                      ))}
                    
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 bg-[#437cdc]">
        <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
          Otros Participantes
        </label>
        </div>
        <div className=" mt-3">
          <button
            type="button"
            onClick={handleClickOnOtrosParticipantes}
            className="block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-[#9e56fe] hover:shadow-lg focus:bg-[#9e56fe] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Agregar Otros Participantes
          </button>
        </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto ">
            <div className="py-4 inline-block min-w-full ">
              <div className="overflow-hidden">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className="">
                    <tr>
                      <th></th>
                    <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Código
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Nombre
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Tipo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Tipos Honorario
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Código
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Especialidad
                      </th>
                      
                    </tr>
                  </thead>
                  
                    {
                      dataOtrosParticipantes.map((item,index)=>(
                        <TablaOtrosParticipantes item={item} key={index} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}/>
                      ))
                    }
                  
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 bg-[#437cdc]">
        <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
          Paquetes / Materiales / Insumos
        </label>
        </div>
        <div className="mt-3">
          <button
            type="button"
            onClick={handleOnchangeAgregarPaquetesQuirurgicos}
            className="block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-[#9e56fe] hover:shadow-lg focus:bg-[#9e56fe] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#9e56fe] active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Agregar, Ver o Eliminar Paquetes Quirurgicos
          </button>
        </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto ">
            <div className="py-4 inline-block min-w-full ">
              <div className="overflow-hidden">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className="">
                    <tr>
                      <th>
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Código
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Cantidad
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Empresa
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      dataInsumosPaquetesMateriales.map((item,index)=>(
                        <TablaPaquetesMaterialesInsumos key={index} item={item}/>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          {/* <button type="button"
              onClick={handleCancelClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal">
              Cancelar
              </button> */}
          <button
            type="submit"
            onClick={handleOnclickGuardar}
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Guardar
          </button>
        </div>
      </div>
      {modalOnOtrosParticipantes? <ModalOtrosParticipantesCirugia setModalOnOtrosParticipantes={setModalOnOtrosParticipantes} idCirugia={idCirugia} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}/>:null}
      {modalOnAgregarProcedimientoCirugia? <ModalAgregarProcedimientoDeCirugia setmodalOnAgregarProcedimientoCirugia={setmodalOnAgregarProcedimientoCirugia} idCirugia={idCirugia} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento} user={user}/>:null}
      {modalOnAgregarPaquetesQuirurgicos? <ModalAgregarPaquetesQuirurgicos setmodalOnAgregarPaquetesQuirurgicos={setmodalOnAgregarPaquetesQuirurgicos} idCirugia={idCirugia} user={user} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}/>:null}
      {modalOnConfirmarGuardar? <ModalConfirmarGuardarPro setmodalOnConfirmarGuardar={setmodalOnConfirmarGuardar} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>:null}
    </>
  );
};

export default ModalProcedimiento;
